import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatPaginator,
  MatSort,
  MatTableDataSource,
  PageEvent,
} from "@angular/material";
import { ReportLogService } from "src/app/services/report-log.service";
import { TravelerService } from "src/app/services/traveler.service";
import { UtilityService } from "src/app/services/utility.service";
import * as XLSX from "xlsx";

@Component({
  selector: "app-report-log-traveler-complete-flight-update",
  templateUrl: "./report-log-traveler-complete-flight-update.component.html",
  styleUrls: ["./report-log-traveler-complete-flight-update.component.css"],
})
export class ReportLogTravelerCompleteFlightUpdateComponent implements OnInit {
  model: any = {};
  yearList: any = [];
  tripOptionList = [];
  alltripList = [];
  years = "";
  tripId = "";
  searchText = "";
  isSearch = false;
  previousPageSizeOptions: number[] = [];
  pageSizeOptions: number[] = [5, 10, 20, 50];

  public displayedColumns = [
    "formattedDate",
    "formattedTime",
    "updatedByName",
    "status",
    "tripCode",
    "ppeWhsCode",
    "salesmanCode",
    "customerNumber",
    "companyName",
    "groups",
    "legalName",
    "gender",
    "nickName",
    "dateofBirthDisplay",
    "cellPhone",
    "emailAddress",
    "flightType",
    "flightRowNumber",
    "recordLocator",
    "recordLocatorOld",
    "ticketNumber",
    "ticketNumberOld",
    "ticketCost",
    "ticketCostOld",
    "airlineCode",
    "airlineCodeOld",
    "flightNumber",
    "flightNumberOld",
    "departureAirport",
    "departureAirportOld",
    "departureDateDisplay",
    "departureDateOldDisplay",
    "departureTime",
    "departureTimeOld",
    "arrivalAirport",
    "arrivalAirportOld",
    "arrivalDateDisplay",
    "arrivalDateOldDisplay",
    "arrivalTime",
    "arrivalTimeOld",
  ];

  public dataSource = new MatTableDataSource<UpdatedTravelerEntity>();
  @ViewChild(MatPaginator, { static: true })
  resultsLength = 0;
  pageSize = 25;
  pageEvent: PageEvent;

  paginator: MatPaginator;
  @ViewChild(MatSort, { static: true })
  sort: MatSort;
  response: any = {};

  constructor(
    private travelerService: TravelerService,
    public _utilityService: UtilityService,
    private reportLogService: ReportLogService
  ) {}

  ngOnInit() {
    this.yearList = this._utilityService.fillYear(
      new Date().getFullYear() - 3,
      new Date().getFullYear() + 1
    );
    this.travelerService.getTripCodeList().subscribe((result) => {
      this.alltripList = result;
    });
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  updatedFlightList(searchText) {
    this.dataSource.data = [];
    let pageIndex = this.pageEvent ? this.pageEvent.pageIndex + 1 : 1;
    const pageSize = this.pageEvent ? this.pageEvent.pageSize : this.pageSize;

    if (searchText) {
      pageIndex = 1;
    }
    if (+this.tripId > 0 && +this.years > 0) {
      this.reportLogService
        .getTravelerCompleteFlightDetailUpdateList(
          +this.years,
          +this.tripId,
          pageIndex,
          this.pageSize,
          this.searchText
        )
        .subscribe((result) => {
          this.model = this.dataSource.data =
            result.data as UpdatedTravelerEntity[];
          this.resultsLength = result.totalCount;
          if (this.paginator) {
            this.paginator.pageSize = pageSize;
            this.paginator.length = this.resultsLength;
          }
        });
    }
  }
  loadPage() {
    this.updatedFlightList(this.searchText);
  }
  areArraysEqual(array1: number[], array2: number[]): boolean {
    if (array1.length !== array2.length) return false;
    for (let i = 0; i < array1.length; i++) {
      if (array1[i] !== array2[i]) return false;
    }
    return true;
  }

  changeYear() {
    this.tripId = "";
    this.tripOptionList = [];
    if (this.alltripList && this.alltripList.length > 0)
      this.tripOptionList = this.alltripList.filter(
        (t) => t.years === this.years
      );
    this.dataSource.data = [];
  }

  changeTrip() {
    this.updatedFlightList(this.searchText);
  }
  applyFilter(filterValue: string) {
    this.searchText = filterValue.trim().toLowerCase();
    this.updatedFlightList(this.searchText);
  }

  exportToExcel(): void {
    const pageIndex = 1;
    const pageSize = this.resultsLength;

    if (+this.tripId > 0 && +this.years > 0) {
      this.reportLogService
        .getTravelerCompleteFlightDetailUpdateList(
          +this.years,
          +this.tripId,
          pageIndex,
          pageSize,
          this.searchText
        )
        .subscribe((result) => {
          const sortedData = this.dataSource.sortData(
            result.data as UpdatedTravelerEntity[],
            this.sort
          );

          const data = sortedData.map((item) => {
            return {
              Date: item.formattedDate,
              Time: item.formattedTime + " " + "Hrs",
              "Updated By": item.updatedByName,
              Status: item.status,
              "Trip Code": item.tripCode,
              Whs: item.ppeWhsCode,
              Salesman: item.salesmanCode,
              "Customer#": item.customerNumber,
              "Company Name": item.companyName.replace(/&#39;/g, "'"),
              Groups: item.groups,
              "Legal Name": item.legalName,
              Gender: item.gender == 1 ? "M" : "F",
              "Nick Name": item.nickName,
              "Date of Birth": item.dateofBirthDisplay,
              "Cell Phone": item.cellPhone,
              Email: item.emailAddress,
              "Flight Type": item.flightType,
              Flight: item.flightRowNumber,
              "Record Locator": item.recordLocator,
              "Old Record Locator": item.recordLocatorOld,
              "Ticket Number": item.ticketNumber,
              "Old Ticket Number": item.ticketNumberOld,
              "Cost Of flight": item.ticketCost,
              "Old Cost Of flight": item.ticketCostOld,
              Airline: item.airlineCode,
              "Old Airline": item.airlineCodeOld,
              "Flight Number": item.flightNumber,
              "Old Flight Number": item.flightNumberOld,
              "Airport (Departure / Return)": item.departureAirport,
              "Old Airport (Departure / Return)": item.departureAirportOld,
              "Date (Departure / Return)": item.departureDateDisplay,
              "Old Date (Departure / Return)": item.departureDateOldDisplay,
              "Time (Departure / Return)": item.departureTime,
              "Old Time (Departure / Return)": item.departureTimeOld,
              "Arrival Airport": item.arrivalAirport,
              "Old Arrival Airport": item.arrivalAirportOld,
              "Arrival Date": item.arrivalDateDisplay,
              "Old Arrival Date": item.arrivalDateOldDisplay,
              "Arrival Time": item.arrivalTime,
              "Old Arrival Time": item.arrivalTimeOld,
            };
          });
          const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Traveler-Complete-Flight");
          XLSX.writeFile(
            wb,
            `Traveler-Complete-Flight-Report_${this._utilityService.getCurrentDateTime()}.xlsx`
          );
        });
    }
  }
}

export interface UpdatedTravelerEntity {
  id: number;
  enrollmentId: number;
  updatedOnDisplay: string;
  updatedByName: string;
  tripCode: string;
  ppeWhsCode: string;
  salesmanCode: string;
  customerNumber: string;
  companyName: string;
  groups: number;
  legalName: string;
  gender: number;
  nickName: string;
  dateofBirthDisplay: string;
  cellPhone: string;
  emailAddress: string;
  flightRowNumber: number;
  recordLocator: string;
  recordLocatorOld: string;
  ticketNumber: string;
  ticketNumberOld: string;
  ticketCost: number;
  ticketCostOld: number;
  airlineCode: string;
  airlineCodeOld: string;
  flightNumber: string;
  flightNumberOld: string;
  departureAirport: string;
  departureAirportOld: string;
  departureDateDisplay: string;
  departureDateOldDisplay: string;
  departureTime: string;
  departureTimeOld: string;
  arrivalAirport: string;
  arrivalAirportOld: string;
  arrivalDateDisplay: string;
  arrivalDateOldDisplay: string;
  arrivalTime: string;
  arrivalTimeOld: string;
  flightType: string;
  formattedDate: string;
  formattedTime: string;
  status: string;
}
